import {getFromStore, StorePath} from './store.service';
import {Settings} from '../models/snippet-payload.model';
import {DealerInfo} from '../models/dealership.model';
import {OFFER_SOURCE_TO_FTC_KEY, OfferModel} from '../models/offer.model';
import {isLocalhost} from './environment.service';

export const getClientDisplayName = (): string | null => {
	const customClientName = (getFromStore(StorePath.SETTINGS) as Settings)?.gpt_settings?.custom_client_name as string | null;
	const dealerInfoName = (getFromStore(StorePath.DEALER_INFO) as DealerInfo)?.name as string | null;
	return customClientName || dealerInfoName;
};

const shouldShowFtcComplianceRequiredFields = (): boolean => {
	return isLocalhost();
};

export const isRequiredForFtc = (offer: OfferModel): boolean => {
	if (!offer) {
		return false;
	}
	if (!shouldShowFtcComplianceRequiredFields()) {
		return false;
	}
	const key = OFFER_SOURCE_TO_FTC_KEY[offer.type?.toLowerCase() as keyof typeof OFFER_SOURCE_TO_FTC_KEY];
	if (!key) {
		return false;
	}
	const ftcSettings = (getFromStore(StorePath.SETTINGS) as Settings)?.ftc;
	return ftcSettings?.['widget']?.[key] === true;
};
